var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRadio = function SvgIconRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.75 13.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M15 12.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.625a1 1 0 0 1 1-1H9a1 1 0 1 1 0 2H6.75a1 1 0 0 1-1-1M5.75 15.375a1 1 0 0 1 1-1H9a1 1 0 1 1 0 2H6.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.958 2.713a1 1 0 0 1-.67 1.245L9.812 6.5H20.25A1.75 1.75 0 0 1 22 8.25v10.5a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75V7.5a1 1 0 0 1 .713-.958l15-4.5a1 1 0 0 1 1.245.67M4 8.5h16v10H4z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconRadio;